import PropTypes from 'prop-types'

import {cobrandingPrefixText} from '../../lib/cobrandingTools'

import './desktopNavEverplansBrandedCobranding.scss'

const DesktopNavEverplansBrandedCobranding = ({
  cobranding = {
    cobrandable: {name: ''},
    cobranding_prefix: '',
    logo_url: ''
  }
}) => {
  if (!cobranding.logo_url) return null

  return (
    <div className='desktop-nav-everplans-branded-cobranding'>
      {cobranding.cobranding_prefix}
      <img
        alt={cobrandingPrefixText(cobranding)}
        src={cobranding.logo_url}
      />
    </div>
  )
}

DesktopNavEverplansBrandedCobranding.propTypes = {
  cobranding: PropTypes.shape({
    cobrandable: PropTypes.shape({
      name: PropTypes.string
    }),
    cobranding_prefix: PropTypes.string,
    logo_url: PropTypes.string
  })
}

export default DesktopNavEverplansBrandedCobranding
